import { agentFragment } from './fragmentsAgent';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const agentSetToolsMutationAtom = createMutationAtomFactory(
  'admin.agentSetTools',
  (params: { id: string; toolIds: string[] }) => ({
    assistantSetAgentTools: {
      __args: {
        id: params.id,
        input: {
          toolIds: params.toolIds,
        },
      },
      ...agentFragment,
    },
  }),
);
